import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			units1: [],
			units2: [],
			count1: null,
			count2: null,
		};
	},

	mounted: function () {
		this.observeVisibility();
	},

	beforeMount: function () {
		var results1 = this.$el.getElementsByClassName('unit-list-section1');
		if (results1.length) {
			this.resultFields = findResultFields(results1[0].innerHTML, this.$el);
		}

	},
	updated: function () {
		this.applySlider("similar1");
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();
	},
	methods: {

		toogleTabs: function (value) {

			//console.log('toogleTabs', value);
			var other1 = null;
			if (value == 1) {
				other1 = 2;
			} else if (value == 2) {
				other1 = 1;
				this.applySlider("similar2");

			}

			$('.tab').removeClass('active');

			$('.tab' + value).addClass('active');

			$('#similarsection' + value).css({
				'display': 'block',
				'z-index': '3',
				'visibility': 'visible'
			});


			$('#similarsection' + other1).css({
				'display': 'none',
				'z-index': '0',
				'visibility': 'hidden'
			});

		},

		observeVisibility() {
			const options = {
				root: null,
				rootMargin: '0px 0px 0px 0px',
				threshold: 0 // Einstellen Sie den Schwellenwert basierend auf Ihren Anforderungen
			};

			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						this.search4similar1();
						this.search4similar2();
						observer.unobserve(entry.target);
					}
				});
			};

			const observer = new IntersectionObserver(callback, options);
			observer.observe(document.getElementById('similarunits'));
		},

		search4similar1: function () {
			//console.log('Ich lege jetzt los!!!');

			var beds = 2;
			let el = document.querySelector("[data-beds]");
			if (el) {
				beds = parseInt(el.getAttribute('data-beds'), 10);
			} else {
				//console.log('element beds is not found..................');
			}
			var unitId;
			let e2 = document.querySelector("[data-unit-id]");
			if (e2) {
				unitId = parseInt(e2.getAttribute('data-unit-id'));
				//console.log('Unit id int:' + unitId);
			}
			var req;

			if (beds) {
				req = {
					fields: this.resultFields,
					filter: {
						'beds': beds
					},
					max: 6,
					sorting: 'random'
				};

				doReq('searchUnits', req)
					.then((res) => {
						var foundUnits = [];
						if (res.units.length) {
							for (let i = 0; i < res.units.length; i++) {
								if (res.units[i]._id !== unitId) {
									foundUnits.push(res.units[i]);
								}

							}
						}
						this.count1 = foundUnits.length;
						this.units1 = foundUnits;


					});
			}
		},

		search4similar2: function () {
			var region = null;
			let el = document.querySelector("[data-region-id]");
			if (el) {
				region = parseInt(el.getAttribute('data-region-id'), 10);
			} else {
				//console.log('element region is not found..................');
			}
			var unitId;
			let e2 = document.querySelector("[data-unit-id]");
			if (e2) {
				unitId = parseInt(e2.getAttribute('data-unit-id'));
				//console.log('Unit id int:' + unitId);
			}
			var req;

			if (region) {
				req = {
					fields: this.resultFields,
					filter: {
						'region.id': region
					},
					max: 6,
					sorting: 'random'
				};

				doReq('searchUnits', req)
					.then((res) => {
						var foundUnits = [];
						if (res.units.length) {
							for (let i = 0; i < res.units.length; i++) {
								if (res.units[i]._id !== unitId) {
									foundUnits.push(res.units[i]);
								}

							}
						}
						this.count2 = foundUnits.length;
						this.units2 = foundUnits;


					});
			}
		},
		getUnitSearchTarget: function (id) {
			if (window.screen.width < 768) {
				return '_self';
			} else {
				return 'unit_' + id;
			}
		},

		applySlider(sliderClass) {
			const $carousel = $(`.owl-carousel.${sliderClass}`);
			const $wrapper = $carousel.closest(".carousel-wrapper");

			// Keyboard- vs. Maus-Nutzung
			let isUsingKeyboard = false;
			window.addEventListener('keydown', (e) => {
				if (e.key === 'Tab') isUsingKeyboard = true;
			});
			window.addEventListener('mousedown', () => {
				isUsingKeyboard = false;
			});

			if (!$carousel.hasClass('owl-loaded')) {
				$carousel.owlCarousel({
					loop: false,
					margin: VOFFICE.settings.olwCarouselMargin,
					smartSpeed: 1000,
					autoplay: false,
					nav: VOFFICE.settings.olwCarouselNav,
					dots: true,
					responsive: {
						0: {
							items: 1
						},
						768: {
							items: 2
						},
						993: {
							items: 3
						},
						1200: {
							items: 3
						}
					},
					onInitialized: function (event) {
						$(event.target).addClass('show');
						updateDots();
					}
				});
			}

			function updateDots() {
				$carousel.find('.owl-dot').each(function (index) {
					$(this).find('span').html(`<span class="sr-only">Gehe zu Slide ${index + 1}</span>`);
					$(this).attr('aria-label', `Gehe zu Slide ${index + 1}`);
				});
			}

			function updateTabindex() {
				$carousel.find(".owl-item").each(function () {
					const $item = $(this);
					$item.find('a, button, input, select, textarea, [tabindex]').each(function () {
						if (!$item.hasClass("active")) {
							$(this).attr("tabindex", "-1");
						} else {
							if ($(this).attr("tabindex") === "-1" && !$(this).hasClass("notremovetabindex")) {
								$(this).removeAttr("tabindex");
							}
						}
					});
				});
			}

			// Initial Tabindex setzen
			updateTabindex();

			const that = this;

			const $navButtons = $wrapper.find(".owl-prev, .owl-next");
			$navButtons.attr({
				"tabindex": "0",
				"aria-label": function () {
					return $(this).hasClass('owl-prev') ? that.voMsg('tpl.text.prevSlide') : that.voMsg('tpl.text.nextSlide');
				}
			});

			$navButtons
				.off('focus.keyboard-focus blur.keyboard-focus')
				.on('focus.keyboard-focus', function () {
					if (isUsingKeyboard) $(this).addClass('keyboard-focus');
				})
				.on('blur.keyboard-focus', function () {
					$(this).removeClass('keyboard-focus');
				});

			$wrapper.attr("tabindex", "0").off("keydown.owlNav").on("keydown.owlNav", function (e) {
				if (e.key === "ArrowLeft") {
					$carousel.trigger("prev.owl.carousel");
					e.preventDefault();
				} else if (e.key === "ArrowRight") {
					$carousel.trigger("next.owl.carousel");
					e.preventDefault();
				}
			});

			$carousel.off("changed.owl.carousel.custom").on("changed.owl.carousel.custom", function () {
				setTimeout(() => updateTabindex(), 100);
			});
		},



	}

};